module.exports = __webpack_public_path__ + "img/embaixo7.53f8a2fc.jpg";